import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Icon, Modal, Table } from 'antd';
import uuidv4 from 'uuid/v4';
import store from '../../reducers/store';
import EditFilterModal from './EditModal';
import columns from './TableColumns';
import updateUserProfile from '../../userFunctions/updateUserProfile';
import filterService from '../../services/filterService';
import userService from '../../services/userService';

const confirm = Modal.confirm;

class RatingBumps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      showEditModal: false,
      type: '',
      action: '',
      RatingBumpFilter: {},
      key: '',
    };
  }

  generateCountiesList(counties) {
    let countyList = [];
    if (Object.keys(counties).length == 0) countyList.push('All');
    else {
      Object.keys(counties).forEach((state) => {
        counties[state].forEach((county) => {
          countyList.push(state + ': ' + county);
        });
      });
    }

    return countyList;
  }

  updateFilterRows(RatingBumpList) {
    if (!RatingBumpList) return;
    const data = [];
    for (const filter of RatingBumpList) {
      data.push(this.generateDataFromFilter(filter));
    }

    this.setState({
      filters: data,
    });
    this.setState({
      filters: data,
    });
  }

  generateDataFromFilter(filter) {
    const filterValues = filter.filterValues || [];
    const rating = [];
    const position = [];
    const year = [];
    const locationState = [];
    const locationCounty = [];

    for (const value of filterValues) {
      if (value.filterValueType.name === 'rating') {
        rating.push(value);
      } else if (value.filterValueType.name === 'position') {
        position.push(value);
      } else if (value.filterValueType.name === 'year') {
        year.push(value);
      } else if (value.filterValueType.name === 'locationState') {
        locationState.push(value);
      } else if (value.filterValueType.name === 'locationCounty') {
        locationCounty.push(value);
      }
    }

    const obj = {
      key: filter.id,
      pos: this.generatePosition(position),
      years: this.generateYears(year),
      range: this.generateRange(rating),
    };

    const counties = this.generateCounties(locationState, locationCounty);

    return { ...obj, ...counties };
  }

  generateCounties(locationState, locationCounty) {
    if (locationCounty.length === 0 && locationState.length === 0) {
      return { counties: 'All', countyObj: {} };
    }
    const locationObj = {};
    const locationArray = [];
    for (const stateValue of locationState) {
      for (const state of this.props.states) {
        if (state.id === stateValue.value) {
          locationArray.push(state.name);
          locationObj[state.name] = ['All'];
        }
      }
    }
    for (const countyValue of locationCounty) {
      for (const state of this.props.states) {
        for (const county of state.counties) {
          if (county.id === countyValue.value) {
            locationArray.push(county.name);
            if (locationObj[state.name]) {
              locationObj[state.name].push(county.name);
            } else {
              locationObj[state.name] = [county.name];
            }
          }
        }
      }
    }
    return { counties: locationArray.join(', '), countyObj: locationObj };
  }

  generatePosition(positionArr) {
    if (positionArr.length === 0) {
      return 'All';
    }
    const positionList = [];
    for (const positionValue of positionArr) {
      const index = this.props.positions.findIndex((position) => {
        return position.id === positionValue.value;
      });
      if (index > -1) {
        positionList.push(this.props.positions[index].name);
      }
    }
    return positionList.join(',');
  }

  generateYears(yearsArr) {
    if (yearsArr.length === 0) {
      return 'All';
    }
    return yearsArr
      .map((year) => {
        return year.value;
      })
      .join(',');
  }

  generateRange(ratingsArr) {
    let min = 0;
    let max = 100;
    for (const rating of ratingsArr) {
      if (rating.value) {
        min = rating.value[0];
        max = rating.value[1];
      }
    }
    return min + '-' + max;
  }

  showConfirmDeleteFilter(key) {
    var that = this;
    confirm({
      title: 'Are you sure you want to delete this filter?',
      onOk() {
        that.deleteFilter(key);
        return;
      },
      onCancel() {
        return;
      },
    });
  }

  handleDispatch(data) {
    const currentUserIdx = this.props.schoolUsersList.findIndex((user) => {
      return user.id === this.props.displayedUser.id;
    });
    this.props.schoolUsersList[currentUserIdx].filters = data.filters;

    store.dispatch({
      type: 'UPDATE_SCHOOL_USERS_LIST',
      schoolUsersList: this.props.schoolUsersList,
    });
    store.dispatch({ type: 'UPDATE_ACTIVE_USER', activeUser: data });
    store.dispatch({ type: 'UPDATE_DISPLAYED_USER', displayedUser: data });
    store.dispatch({ type: 'UPDATE_FILTERS', filters: data.filters });
    store.dispatch({ type: 'UPDATE_ORG', organization: data.organization });

    return;
  }

  deleteFilter(key) {
    filterService.deleteFilter(key).then(async (filter) => {
      const responseData = await userService.getUser(this.props.displayedUser.id);
      this.handleDispatch(responseData);
    });
  }

  openEditModal(type, action, record) {
    this.setState({
      showEditModal: true,
      type: type,
      action: action,
      RatingBumpFilter: record.key !== '' ? JSON.parse(JSON.stringify(record)) : {},
      key: record.key,
    });
  }

  handleOk(childState, key) {
    var newRatingBumpFilter = {
      position: childState.pos,
      county: childState.counties,
      year: childState.years,
      range: childState.sliderRange,
      key: key,
      type: 'ratingBump',
      user: this.props.displayedUser,
    };
    if (newRatingBumpFilter.key) {
      filterService.editFilter(newRatingBumpFilter).then(async (filter) => {
        const responseData = await userService.getUser(this.props.displayedUser.id);
        this.handleDispatch(responseData);
      });
    } else {
      filterService.createRatingBumpFilter(newRatingBumpFilter).then(async (filter) => {
        const responseData = await userService.getUser(this.props.displayedUser.id);
        this.handleDispatch(responseData);
      });
    }

    this.setState({
      showEditModal: false,
      // type: "",
      action: '',
      key: '',
    });
  }

  handleCancel(childState, isEquivalent) {
    var newRatingBumpFilter = {
      position: childState.pos,
      county: childState.counties,
      year: childState.years,
      range: childState.sliderRange,
    };

    var defaultFilter = {
      position: ['All'],
      county: {},
      year: ['All'],
      range: [0.6, 1],
    };

    // Zcruit users only
    if (this.props.redirected && localStorage.zcruitLite === 'false') {
      newRatingBumpFilter.minZMax = childState.minZMax;
      defaultFilter.minZMax = 0;
    }

    var newRatingBumpFilters = JSON.parse(JSON.stringify(this.props.RatingBumpList));
    var previousFilter;

    if (this.state.key != '') {
      previousFilter = newRatingBumpFilters[this.state.key];
    } else {
      previousFilter = defaultFilter;
    }

    var closeModal = () => {
      this.setState({
        showEditModal: false,
        RatingBumpFilter: {},
        // type: "",
        action: '',
        key: '',
      });
    };

    if (isEquivalent(newRatingBumpFilter, newRatingBumpFilter)) {
      closeModal();
    } else {
      return new Promise((res, rej) => {
        confirm({
          title: 'Are you sure you want to close?',
          content: 'The filter settings have not been saved',
          onOk() {
            closeModal();
          },
          onCancel() {
            false;
          },
        });
      });
    }
  }

  componentWillMount() {
    if (
      typeof this.props.displayedUser.filters === 'undefined' ||
      this.props.displayedUser.filters.length === 0
    ) {
      return;
    }

    this.updateFilterRows(
      this.props.displayedUser.filters.filter((f) => f.filterCategory.name === 'ratingBump')
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.displayedUser.filters === 'undefined' ||
      nextProps.displayedUser.filters.length === 0
    ) {
      this.updateFilterRows([]);
      return;
    }

    this.updateFilterRows(
      nextProps.displayedUser.filters.filter((f) => f.filterCategory.name === 'ratingBump')
    );
  }

  render() {
    const optionsColumn = [
      {
        title: '',
        key: 'options',
        width: 50,
        render: (text, record) => (
          <div className='row-option edit-delete-container'>
            <Icon
              type='edit'
              role='button'
              tabIndex={0}
              aria-label='Edit Filter'
              onClick={() => {
                this.openEditModal('RatingBump', 'Edit', record);
              }}
            />
            <Icon
              type='close-square-o'
              role='button'
              tabIndex={0}
              aria-label='Delete Filter'
              onClick={() => {
                this.showConfirmDeleteFilter(record.key);
              }}
            />
          </div>
        ),
      },
    ];

    const RatingBumpsColumns = true
      ? columns.ZmailRatingBumpsColumns.concat(optionsColumn)
      : columns.ZcruitRatingBumpsColumns.concat(optionsColumn);

    return (
      <div>
        <Table
          columns={RatingBumpsColumns}
          dataSource={this.state.filters}
          locale={{ emptyText: 'No Rating Bumps Filters' }}
          title={() => (
            <div>
              <span className='table-title-span'>Rating Bumps</span>{' '}
              <Button
                style={{ float: 'right' }}
                type='primary'
                className='addButton'
                aria-label='Add a Ratings Bump Filter'
                onClick={this.openEditModal.bind(this, 'RatingBump', 'Add', '')}>
                + Add
              </Button>
            </div>
          )}
          pagination={false}
        />
        <EditFilterModal
          visible={this.state.showEditModal}
          type={this.state.type}
          action={this.state.action}
          filter={this.state.RatingBumpFilter}
          handleOk={this.handleOk.bind(this)}
          handleCancel={this.handleCancel.bind(this)}
        />
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    RatingBumpList: storeState.lists.RatingBumpList,
    redirected: storeState.main.redirected,
    displayedUser: storeState.main.displayedUser,
    states: storeState.main.states,
    positions: storeState.main.positions,
    schoolUsersList: storeState.lists.schoolUsersList,
  };
}

export default connect(mapStoreToProps)(RatingBumps);



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/RatingBumps.js